<template>
    <Transition appear
                :name="async ? 'slide' : 'fade'">

        <section class="py-2 t3m-Section t3m-Section--flx isolate"
                 ref="section"
                 :class="[
                     `t3m-Section--flx-${getSize} t3m-Section--flx-${getContentType}`,
                     getTheme,
                 ]">
            <v-section-header :title="title"
                              :slides="slides" />
            <div class="t3m-Section-body t3m-Section-body--flx group"
                 ref="sectionBody">
                <div v-if="type === 'carousel'">
                    <carousel :slides="slides"
                              :connectToBillboard="(!connectToBillboard || connectToBillboard == 0) ? false : true"
                              :keyFacts="keyFacts == 1 ? true : false"
                              :contentType="contentType"
                              :size="getSize"
                              :introduction="introduction || undefined" />
                </div>
                <div v-else-if="type === 'default'">Default</div>
                <div v-else>Not A/B/C</div>
            </div>
            <v-section-details v-if="showDetails" />
        </section>
    </Transition>
</template>

<script>
// import Vue from "vue";
import { mapState } from "vuex";
import VSectionHeader from "@/components/VSectionHeader.vue";
import Carousel from "@/components/Carousel.vue";
import VSectionDetails from "@/components/VSectionDetails.vue";
import { Transition } from "vue";

export default {
    name: "VSection",
    components: {
        Carousel,
        VSectionHeader,
        VSectionDetails,
        Transition
    },
    props: {
        id: String,
        type: String,
        title: String,
        slides: Object,
        connectToBillboard: String,
        keyFacts: String,
        contentType: String,
        size: String,
        introduction: String,
    },
    computed: {
        ...mapState(["selectedCard", "billboardItem"]),
        showDetails: function () {
            if (this.selectedCard) {
                return Object.values(this.slides).filter((s) => {
                    return s.id === this.selectedCard.id;
                }).length;
            } else {
                return undefined;
            }
        },
        getSize: function () {
            return this.size || "auto";
        },
        getContentType: function () {
            return this.contentType || "noContentType";
        },
        getTheme: function () {
            return this.billboardItem && this.connectToBillboard == 1
                ? this.billboardItem.theme
                : "";
        },
    },
};
</script>
